import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "../../../molecules";
import { actions as modalActions } from "../../Modal/modal.reducers";
import { selectItemToBeDeleted } from "../../Modal";
import Spinner from "../../Spinner";
import { EMPTY_STRING, ENTER_KEY_CODE } from "../../../../constants";

const { setSelectedModal, setItemToBeDeleted } = modalActions;

const DeleteConfirmationModal = ({
  handleDelete,
  setShouldShowDeleteModal,
  title,
  spinner = "delete",
  shouldShowConfirmationTextbox = true,
}) => {
  const dispatch = useDispatch();
  const itemToBeDeleted = useSelector(selectItemToBeDeleted);

  const [selectedItem, setSelectedItem] = useState({ name: EMPTY_STRING });
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [isSpinnerActive, setIsSpinnerActive] = useState(false);

  const handleKeyDown = (event) => {
    if (event.keyCode === ENTER_KEY_CODE && isConfirmed && handleDelete(itemToBeDeleted));
  };

  useEffect(() => {
    itemToBeDeleted && setSelectedItem(itemToBeDeleted);
  }, [itemToBeDeleted]);

  const checkIsButtonDisabled = () => {
    if (!shouldShowConfirmationTextbox) return isSpinnerActive;
    else return (title && !isConfirmed) || isSpinnerActive;
  };

  const handleClose = useCallback(() => {
    dispatch(setSelectedModal(null));
    setShouldShowDeleteModal(false);
    dispatch(setItemToBeDeleted(null));
  }, [dispatch, setShouldShowDeleteModal]);

  const footer = (
    <div className="p-4 border-t border-gray-700 flex align-center justify-end">
      <button
        type="button"
        className="btn btn-primary-light mr-1"
        onClick={() => {
          handleClose();
        }}
        disabled={isSpinnerActive}
      >
        Cancel
      </button>
      <button
        type="button"
        onClick={() => handleDelete(itemToBeDeleted)}
        className="btn btn-danger"
        disabled={checkIsButtonDisabled()}
      >
        <Spinner name={spinner} setIsSpinnerActive={setIsSpinnerActive} persistSize>
          {title || !shouldShowConfirmationTextbox ? "Delete" : "Delete Forever"}
        </Spinner>
      </button>
    </div>
  );

  const children = title && (
    <div className="p-6 border-b border-gray-700">
      {shouldShowConfirmationTextbox ? (
        <div>
          <p className="text-sm text-gray-50 mb-2">
            Type
            <span className="font-bold whitespace-pre">
              {` "${selectedItem.name}" `}
            </span>
            to confirm
          </p>
          <div className="form-group">
            <input
              type="text"
              name={title}
              className="form-control"
              placeholder={selectedItem.name}
              autoFocus={true}
              autoComplete="off"
              onChange={(e) =>
                setIsConfirmed(e.target.value === selectedItem.name)
              }
              onKeyDown={handleKeyDown}
            />
          </div>
        </div>
      ) : (
        <p className="text-sm text-gray-50 mb-2">
          Are you sure you want to delete this record?
        </p>
      )}
    </div>
  );

  return (
    <Modal
      title={title}
      subtitle="This action cannot be undone."
      footer={footer}
      handleClose={handleClose}
    >
      {children}
    </Modal>
  );
};
export default DeleteConfirmationModal;
